import React from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
const PhoneInput = ({ title, areaCode, setAreaCode, phoneNumber, handlePhoneInput }) => {
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    return (
        <div className="inputbox-margin">
            <Form.Group className="row mb-2">
                {
                    title &&
                    <div className="inputbox-title">{title}</div>
                }
                <div className="d-flex">
                    <span style={{ width: "100px" }}>
                        <input className="form-control phonecountrycode" type="text" value={currentcountry.country_code} disabled />
                    </span>
                    {
                        currentcountry.isAreaCodeRequired ?
                            <span className="preSpan d-flex ms-2 me-2" style={{ width: "105px", }}>
                                <select
                                    name="pre"
                                    onChange={(e) => setAreaCode(e.target.value)}
                                    value={areaCode}
                                    className=" phoneareacode pl-1 border-0"
                                >
                                    {["50", "52", "54", "55", "56", "58"].map(code => (
                                        <option key={code} value={code}>{code}</option>
                                    ))}
                                </select>
                            </span>
                            :
                            <span className="me-2"></span>
                    }

                    <span style={{ width: "100%" }}>
                        <input
                            type="text"
                            placeholder="Enter Number"
                            className="forminputbox mobileno"
                            value={phoneNumber}
                            onChange={handlePhoneInput}
                        />
                    </span>
                </div>
            </Form.Group>
        </div>
    )
}

export default PhoneInput;
